import { render } from "./SKUDataTable.vue?vue&type=template&id=2fcafd96&scoped=true&ts=true"
import script from "./SKUDataTable.vue?vue&type=script&lang=ts"
export * from "./SKUDataTable.vue?vue&type=script&lang=ts"

import "./SKUDataTable.vue?vue&type=style&index=0&id=2fcafd96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcafd96"]])

export default __exports__